import { render, staticRenderFns } from "./error.vue?vue&type=template&id=bcb5c762&scoped=true&"
var script = {}
import style0 from "./error.vue?vue&type=style&index=0&id=bcb5c762&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb5c762",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Logo: require('/app/components/Logo.vue').default,Button: require('/app/components/Button.vue').default})
